/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  MetricsDataPoint,
  MetricsDataPoint$inboundSchema,
  MetricsDataPoint$Outbound,
  MetricsDataPoint$outboundSchema,
} from "./metricsdatapoint.js";
import {
  MetricsMetadata,
  MetricsMetadata$inboundSchema,
  MetricsMetadata$Outbound,
  MetricsMetadata$outboundSchema,
} from "./metricsmetadata.js";

export type MetricsResponse = {
  /**
   * Array of aggregated data points.
   */
  data?: Array<MetricsDataPoint> | undefined;
  metadata?: MetricsMetadata | undefined;
};

/** @internal */
export const MetricsResponse$inboundSchema: z.ZodType<
  MetricsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  data: z.array(MetricsDataPoint$inboundSchema).optional(),
  metadata: MetricsMetadata$inboundSchema.optional(),
});
/** @internal */
export type MetricsResponse$Outbound = {
  data?: Array<MetricsDataPoint$Outbound> | undefined;
  metadata?: MetricsMetadata$Outbound | undefined;
};

/** @internal */
export const MetricsResponse$outboundSchema: z.ZodType<
  MetricsResponse$Outbound,
  z.ZodTypeDef,
  MetricsResponse
> = z.object({
  data: z.array(MetricsDataPoint$outboundSchema).optional(),
  metadata: MetricsMetadata$outboundSchema.optional(),
});

export function metricsResponseToJSON(
  metricsResponse: MetricsResponse,
): string {
  return JSON.stringify(MetricsResponse$outboundSchema.parse(metricsResponse));
}
export function metricsResponseFromJSON(
  jsonString: string,
): SafeParseResult<MetricsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MetricsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MetricsResponse' from JSON`,
  );
}
